/* Кнопка добавления: стекло Konsta, парит над нижним краем экрана. */

import { Glass } from "konsta/react";
import React from "react";

import { Ion } from "./icons.jsx";

export default function AddButton({
  onClick,
  align = "center",
  label = "Добавить",
  overTabbar = false,
  /** Своя иконка вместо плюса */
  icon: Icon = Ion.add,
}) {
  const place =
    align === "right" ? "right-4" : "left-1/2 -translate-x-1/2";
  /* На экранах с нижней навигацией таббар парит поверх — поднимаем кнопку над ним */
  const base = overTabbar ? 108 : 20;
  return (
    <Glass
      component="button"
      className={`fixed ${place} w-14 h-14 rounded-full flex items-center justify-center active:opacity-70 z-20`}
      style={{
        bottom: `calc(var(--tg-bottom) + ${base}px)`,
        color: "var(--tg-button)",
      }}
      onClick={onClick}
      aria-label={label}
    >
      <Icon size={26} />
    </Glass>
  );
}
